module.exports = __webpack_public_path__ + "img/hamburger.c405c1e4.svg";